import type { ModelLogo } from '@seddi/scene';
import { PropsDiff } from '../core/reconciler/propsDiff';
import { findLogo } from '../domain/scene/scene';
import { type ModelLogoRenderable } from '../renderables/modelLogoRenderable';
import { attachLogo, updateSide, updateTransform } from '../renderables/pieceLogoRenderable';
import type { SceneReconcilerFrame } from './sceneReconcilerFrame';

/**
 * Update logo.
 * @param renderable - Renderable.
 * @param nextProps - Piece logo next.
 * @param prevProps - Piece logo prev.
 * @param frame - Reconciler frame.
 */
export const update = (
  renderable: ModelLogoRenderable,
  nextProps: ModelLogo,
  prevProps: ModelLogo | undefined,
  frame: SceneReconcilerFrame,
): boolean => {
  const { nextScene, resources } = frame;

  const diffProps = PropsDiff.diff(nextProps, prevProps);
  let dirty = false;

  // --- BEGIN SAME CODE AS PIECE LOGO RECONCILER

  // update resource or technique
  if (['resource', 'technique'].some((key) => diffProps.includes(key))) {
    const id = nextProps.resource;

    if (resources.findLogo(id)) {
      attachLogo(renderable, nextProps, resources);
      dirty = true;
    } else {
      if (!resources.hasLogoRequest(id)) {
        const l = findLogo(nextScene, id);
        resources.loadLogoDeferred(l);
      }
    }
  }

  // Update side.
  if (diffProps.includes('side')) {
    updateSide(renderable, nextProps.side);
    dirty = true;
  }

  // Update transform.
  if (['side', 'size', 'transform'].some((key) => diffProps.includes(key))) {
    updateTransform(renderable, nextProps);
    dirty = true;
  }

  // --- END SAME CODE AS PIECE LOGO RECONCILER

  // Update mesh ID.
  if (diffProps.includes('meshId')) {
    renderable.meshId = nextProps.meshId;
    dirty = true;
  }

  return dirty;
};
